import useExecuteQuery from "hooks/useExecuteQuery";

import { GET_ROLES_QUERY } from "graphqlQueries/system";
import { GetRolesMapper } from "graphqlQueries/system.map";

export default function useAddUserDialogFields(isSuperuser = false) {
  const { data, loading } = useExecuteQuery(GET_ROLES_QUERY, {
    dataMapper: GetRolesMapper,
  });

  let roleNames;

  if (isSuperuser) roleNames = ["Superuser"];
  else roleNames = data ? data.map((item) => item.groupName) : [];

  return { loading, roleNames };
}
